var _defs, _circle, _rect, _polygon, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicenceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 100.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bbbcbc;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.62,
    cy: 49.61,
    r: 48.32
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.8,
    y: 53.67,
    width: 12.12,
    height: 3.01
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "49.16 52.25 47.44 48.88 49.3 48.89 49.07 44.22 51.22 48.38 52.94 45.94 53.21 48.5 55.72 47.89 54.44 49.44 56.57 49.96 54.38 50.91 54.38 52.25 57.92 52.25 57.92 40.94 45.8 40.94 45.8 52.25 49.16 52.25"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.8,
    y: 36.48,
    width: 12.12,
    height: 3.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.45,29.23v-.07H29.76v.07a2.89,2.89,0,0,0-2.64,2.59V60.54A2.8,2.8,0,0,0,27.5,62,2.69,2.69,0,0,0,30,63.44H45.77v4h-3a1.32,1.32,0,0,0,0,2.64H60.44a1.32,1.32,0,1,0,0-2.64h-3v-4H73.21A2.67,2.67,0,0,0,75.7,62a2.86,2.86,0,0,0,.41-1.43V31.82A3,3,0,0,0,73.45,29.23Zm0,2.83V60.54c0,.16-.07.24-.24.24H30c-.17,0-.24-.08-.24-.24V31.82H73.45v.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenceIcon);
export default __webpack_public_path__ + "static/media/licence-icon.c00d1a4d5f5a004226ca67ae84e41086.svg";
export { ForwardRef as ReactComponent };